// extracted by mini-css-extract-plugin
export var arrback = "subnav-module--arrback--b0d0e";
export var big = "subnav-module--big--76822";
export var btn = "subnav-module--btn--291fa";
export var copy = "subnav-module--copy--58e01";
export var img = "subnav-module--img--079c3";
export var img_btn = "subnav-module--img_btn--ec4a1";
export var item = "subnav-module--item--b554a";
export var items = "subnav-module--items--cfa53";
export var menu = "subnav-module--menu--4fb17";
export var noscroll = "subnav-module--noscroll--be355";
export var title = "subnav-module--title--c1ed5";
export var wrap = "subnav-module--wrap--9e526";